import React, { useState } from "react";
import PageShell from "../dashboard/PageShell";
import {
  DelegationBasicInfo,
  DelegationContactInfo,
  DelegationFileUpload,
  DelegationFormActions,
} from "../../components/forms/DelegationForm";

interface AddNewOutgoingDelegationProps {}

const AddNewOutgoingDelegation: React.FC<
  AddNewOutgoingDelegationProps
> = () => {
  const [formData, setFormData] = useState({
    country: "",
    organization: "",
    fromDate: "",
    toDate: "",
    quarter: "",
    delegationName: "",
    budget: "",
    budgetSource: "",
    receivingUnit: "",
    purpose: "",
    otherPurpose: "",
    basis: "",
    notes: "",
    attachedFiles: [] as File[],
  });

  const handleInputChange = (field: string, value: string | File[]) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = () => {
    console.log("Saving outgoing delegation data:", formData);
    // TODO: Implement save functionality
  };

  return (
    <PageShell title="Thêm mới Đoàn ra">
      <div className="space-y-4">
        {/* Header Section */}
        <div className="flex justify-between items-center">
          <h1 className="text-xl font-semibold text-gray-800">
            Thêm mới Đoàn ra
          </h1>
        </div>

        {/* Form Section */}
        <div className="bg-white rounded-lg p-4">
          <div className="space-y-4">
            <DelegationBasicInfo
              formData={formData}
              handleInputChange={handleInputChange}
            />

            <DelegationContactInfo
              formData={formData}
              handleInputChange={handleInputChange}
            />

            <DelegationFileUpload
              formData={formData}
              handleInputChange={handleInputChange}
            />
          </div>
        </div>

        <DelegationFormActions
          onSave={handleSave}
          onCancel={() => window.history.back()}
        />
      </div>
    </PageShell>
  );
};

export default AddNewOutgoingDelegation;
